(function () {
  var STATE_KEY = 'haroHomeScrollPosition';

  function pageKey() {
    return window.location.pathname + window.location.search;
  }

  function savePosition(removeAnchor) {
    var currentState = window.history.state;
    var nextState = currentState && typeof currentState === 'object'
      ? Object.assign({}, currentState)
      : {};

    nextState[STATE_KEY] = {
      page: pageKey(),
      y: Math.max(0, Math.round(window.scrollY || window.pageYOffset || 0))
    };

    try {
      var returnUrl = removeAnchor && window.location.hash
        ? window.location.pathname + window.location.search
        : window.location.href;
      window.history.replaceState(nextState, document.title, returnUrl);
    } catch (error) {}
  }

  function restorePosition() {
    var saved = window.history.state && window.history.state[STATE_KEY];
    if (!saved || saved.page !== pageKey() || typeof saved.y !== 'number') return;

    if (window.location.hash) {
      try {
        window.history.replaceState(
          window.history.state,
          document.title,
          window.location.pathname + window.location.search
        );
      } catch (error) {}
    }

    var attempts = 0;
    var maxAttempts = 20;

    function applySavedPosition() {
      var maxScroll = Math.max(
        document.documentElement.scrollHeight,
        document.body ? document.body.scrollHeight : 0
      ) - window.innerHeight;
      var target = Math.min(saved.y, Math.max(0, maxScroll));
      var previousScrollBehavior = document.documentElement.style.scrollBehavior;

      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo({top: target, left: 0, behavior: 'instant'});
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
      attempts += 1;

      if (Math.abs(window.scrollY - saved.y) > 2 && attempts < maxAttempts) {
        window.setTimeout(applySavedPosition, 150);
      }
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(applySavedPosition);
    });
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

    var destination;
    try {
      destination = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    var sameDocument = destination.origin === window.location.origin &&
      destination.pathname === window.location.pathname &&
      destination.search === window.location.search;

    if (!sameDocument) savePosition(true);
  }, true);

  window.addEventListener('pagehide', function () {
    savePosition(false);
  });
  window.addEventListener('pageshow', restorePosition);
})();
